
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.334 4.207c4.084 0 7.583 2.667 8.833 6.375l8.208.042a.85.85 0 01.625.251l8.583 8.584c.167.124.25.374.208.583l.002 21.124a2.615 2.615 0 01-2.626 2.626H14.958a2.615 2.615 0 01-2.625-2.626V22.374C8.666 21.124 6 17.624 6 13.54c0-5.166 4.209-9.333 9.334-9.334zm9.248 8.128c.041.417.083.791.083 1.208 0 5.166-4.207 9.332-9.332 9.332-.417 0-.834-.04-1.25-.083v18.375c0 .5.376.875.876.875h24.25c.5 0 .875-.376.875-.875V20.962h-7.709a.855.855 0 01-.875-.876v-7.708zm-.874 16.082a.897.897 0 011.459-.042l3.25 4.375c.334.459.959.5 1.333.125l1.042-1.001c.374-.374.999-.291 1.333.125l3.75 5.292a.867.867 0 01-.708 1.375h-16.25c-.708 0-1.125-.75-.75-1.333zm11.459-1.458c0 3-4.5 3-4.5 0 0-3.001 4.5-3.001 4.5 0zm-19.835-21c-4.166 0-7.582 3.416-7.582 7.582 0 4.167 3.416 7.585 7.582 7.583 4.167 0 7.583-3.416 7.583-7.583 0-4.166-3.416-7.583-7.582-7.583zm17.917 7.667v5.582h5.583l-5.583-5.582zm-14.626 2.373a.88.88 0 01.876.875c0 .501-.374.876-.833.877H12.04a.88.88 0 01-.875-.875.88.88 0 01.875-.876zm-3.541-7.624c.125-.166.417-.166.542 0l2.166 2.874c.168.209 0 .542-.291.542h-1.167v3.125a.285.285 0 01-.291.292h-1.416a.286.286 0 01-.292-.292v-3.125h-1.167c-.291 0-.457-.333-.25-.542z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    